const IMAGE_EXT_RE = /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i
const PDF_EXT_RE = /\.pdf$/i

function cleanUrl(url) {
  return String(url || '').split(/[?#]/)[0]
}

function getCertificateFileType(url) {
  const path = cleanUrl(url)
  if (IMAGE_EXT_RE.test(path)) return 'image'
  if (PDF_EXT_RE.test(path)) return 'pdf'
  return 'file'
}

function getCertificateFileName(url) {
  const path = cleanUrl(url)
  const encodedName = path.split('/').pop()
  if (!encodedName) return '附件'
  try {
    return decodeURIComponent(encodedName)
  } catch (error) {
    return encodedName
  }
}

module.exports = { getCertificateFileType, getCertificateFileName }
